import { ProFormInstance } from '@ant-design/pro-form';
import { createContext } from 'react';

export interface IOSAnrListContextProps {
  sharedFields?: Record<string, any>;
  setSharedFields?: (fields: Record<string, any>) => void;
  sharedCompareFields?: Record<string, any>;
  setSharedCompareFields?: (fields: Record<string, any>) => void;
  tableForm?: any;
  setTableForm?: (form: ProFormInstance) => void;
}

export const IOSAnrListContext = createContext<IOSAnrListContextProps>({});
